export enum TwoFaSteps {
  SETUP_CONFIRMATION = 'setup-confirmation',
  SETUP_SUCCESS = 'setup-success',
  SETUP_TWO_FA = 'setup-two-fa'
}
